import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Wrapper, Top, Middle, Bottom} from './Hamburger.style';

export class Hamburger extends PureComponent {
  render() {
    const {isClosed} = this.props;
    return (
      <Wrapper>
        <Top isClosed={isClosed} />
        <Middle isClosed={isClosed} />
        <Bottom isClosed={isClosed} />
      </Wrapper>
    );
  }
}

Hamburger.propTypes = {
  isClosed: PropTypes.bool.isRequired
};

export default Hamburger;



// WEBPACK FOOTER //
// ./components/Hamburger/Hamburger.js